import { createContext } from 'react'
import { EventObject, Interpreter, State } from 'xstate'

export interface StateMachineContextProps<
  TContext = unknown,
  TEvent extends EventObject = EventObject,
> {
  context: TContext
  state: State<TContext, TEvent>
  send: Interpreter<TContext>['send']
}

const defaultValue: StateMachineContextProps = {
  context: undefined,
  state: {} as State<unknown, EventObject>,
  send: (() => {}) as unknown as Interpreter<unknown>['send'],
}

export const StateMachineContext = createContext(defaultValue)
